import { Factory } from 'fishery';
import { Note, NoteType } from '../types/Note';

export const noteFactory = Factory.define<Note>(({ sequence }) => {
  const createdByGuid = '3ed120d0-fe19-4cec-b6ff-452281d6afec';
  return {
    body: 'Please call driver asap.',
    createdByGuid,
    createdBy: {
      guid: createdByGuid,
      name: 'Leona Gleichner',
      email: 'Harrison.Kirlin@yahoo.com',
    },
    dateCreated: '2022-08-26T22:28:00.796Z',
    guid: sequence.toString(),
    isBroadcast: false,
    type: NoteType.Update,
    title: null,
    isClientNote: true,
  };
});
